<template>
  <div>
    <div class="questionnaires__contents">
      <Questionnaire
        :questionnaire="questionnaire"
        v-for="questionnaire in questionnaires"
        :key="questionnaire.id"
        v-show="questionnaire.isVisible()"
        @init="updateQuestionnaire"
        @close="updateQuestionnaire"
      />
    </div>

    <div class="questionnaires__buttons" v-if="this.hasActiveButton">
      <QuestionnaireActiveButton
        :questionnaire="questionnaire"
        v-for="questionnaire in inactiveQuestionnaires"
        :key="questionnaire.id"
        @show-questionnaire="updateQuestionnaire"
      />
    </div>

    <QuestionnaireStartButtons :buttons="startButtons" />
  </div>
</template>

<script>
import Questionnaire from "./Questionnaire"
import QuestionnaireActiveButton from "./QuestionnaireActiveButton"
import QuestionnaireStartButtons from "./QuestionnaireStartButtons"
import EventType from "../../../../../common/js/enum/player/event-type"

export default {
  name: "Questionnaires",
  components: {Questionnaire, QuestionnaireActiveButton, QuestionnaireStartButtons},
  props: {
    disableStartButtonQuestionnaireIds: {
      type: Array,
      required: true
    },
    isLive: {
      type: Boolean,
      required: true
    },
    questionnaires: {
      type: Array,
      required: true
    },
    slug: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showQuestionnaireCount: 0
    }
  },
  computed: {
    inactiveQuestionnaires: function() {
      return this.questionnaires.filter(questionnaire => questionnaire.activeButton.isVisible).sort((a, b) => a.updatedAt - b.updatedAt)
    },
    hasActiveButton: function() {
      return this.inactiveQuestionnaires.length !== 0
    },
    startButtons: function() {
      return this.questionnaires
        .filter(questionnaire => !this.disableStartButtonQuestionnaireIds.includes(questionnaire.id) && questionnaire.startButton.isVisible)
        .map(questionnaire => questionnaire.startButton)
    },
    liveQuestionnaires: function() {
      return this.$store.getters["liveQuestionnaire/getByHallSlug"](this.slug)
    }
  },
  watch: {
    liveQuestionnaires(liveQuestionnaires) {
      liveQuestionnaires.forEach(liveQuestionnaire => {
        const questionnaire = this.questionnaires.find(questionnaire => {
          return questionnaire.id === liveQuestionnaire.questionnaireId
        })

        if (!questionnaire) return

        questionnaire.events.forEach(event => {
          if (event.type !== EventType.ANY) return

          if (!event.enabled) return

          if (typeof event.callback !== "function") return

          event.callback.call(this)
        })
      })
    }
  },
  methods: {
    updateQuestionnaire(questionnaire) {
      this.$emit("update-questionnaire", questionnaire)
    }
  }
}
</script>
